import { makeStyles, createMuiTheme } from "@material-ui/core/styles";

// Light + compact theme
export const theme = createMuiTheme({
	palette: { type: "light" },
	typography: { fontSize: 12 },
	props: {
		MuiTextField: { margin: "dense", variant: "outlined", size: "small" },
		MuiFormControl: { margin: "dense", variant: "outlined" },
		MuiButton: { size: "small" },
		MuiInputLabel: { shrink: true },
	},
});

export const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: "100vh",
		overflowY: "auto",
		background: theme.palette.background.default,
		paddingTop: theme.spacing(3),
		paddingBottom: theme.spacing(5),
	},
	paper: {
		padding: theme.spacing(2.5),
		borderRadius: 12,
	},
	preview: {
		border: `1px dashed ${theme.palette.divider}`,
		padding: theme.spacing(1.5),
		borderRadius: 8,
		whiteSpace: "pre-wrap",
		background: theme.palette.background.paper,
	},
}));